import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { SUPPORT_EMAIL } from '@/config/brandConfig';

const MR = { fontFamily: 'Manrope, sans-serif' };

export function MarketingFooter() {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-border/40 py-10 md:py-12 bg-[hsl(220,15%,4%)]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-12 gap-8 mb-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary/10 border border-primary/15 flex items-center justify-center">
                <svg className="w-4 h-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-label="YBV logo"><line x1="12" y1="2" x2="12" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              </div>
              <span className="text-sm font-semibold text-foreground" style={MR}>YBV</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-sm">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="text-xs font-semibold text-muted-foreground/60 uppercase tracking-[0.15em] mb-4" style={MR}>{t.footer.platformTitle}</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/briefing" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.requestBriefing}</Link></li>
              <li><Link to="/club-demo" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.clubDemo}</Link></li>
              <li><Link to="/world-cup-brand-index" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-wcbi-link">{t.footer.wcbi}</Link></li>
              <li><Link to="/login" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.signIn}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-muted-foreground/60 uppercase tracking-[0.15em] mb-4" style={MR}>{t.footer.legalTitle}</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/privacy-policy" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.privacy}</Link></li>
              <li><Link to="/terms-and-conditions" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.terms}</Link></li>
              <li><Link to="/legal-notice" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.legalNotice}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-muted-foreground/60 uppercase tracking-[0.15em] mb-4" style={MR}>{t.footer.contactTitle}</h4>
            <p className="text-sm text-muted-foreground">{SUPPORT_EMAIL}</p>
          </div>
        </div>

        <div className="pt-8 border-t border-border/30">
          <p className="text-[10px] text-muted-foreground/35 max-w-3xl leading-relaxed">
            {t.footer.disclaimer}
          </p>
          <p className="text-[11px] text-muted-foreground/30 mt-3">
            &copy; {new Date().getFullYear()} {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default MarketingFooter;
